import * as types from './providerRequestActionType';

export const fetchProviderRequestsRequest = (payload) => ({
    type: types.FETCH_PROVIDER_REQUESTS_REQUEST,
    payload,
});

export const fetchProviderRequestsSuccess = (payload) => ({
    type: types.FETCH_PROVIDER_REQUESTS_SUCCESS,
    payload,
});

export const fetchProviderRequestsFailure = (payload) => ({
    type: types.FETCH_PROVIDER_REQUESTS_FAILURE,
    payload,
});

export const fetchProviderRequestDropdownsRequest = () => ({
    type: types.FETCH_PROVIDER_REQUEST_DROPDOWNS_REQUEST,
});

export const fetchProviderRequestDropdownsSuccess = (payload) => ({
    type: types.FETCH_PROVIDER_REQUEST_DROPDOWNS_SUCCESS,
    payload,
});

export const fetchProviderRequestDropdownsFailure = (payload) => ({
    type: types.FETCH_PROVIDER_REQUEST_DROPDOWNS_FAILURE,
    payload,
});

export const updateProviderRequestStatusRequest = (payload) => ({
    type: types.UPDATE_PROVIDER_REQUEST_STATUS_REQUEST,
    payload,
});

export const updateProviderRequestStatusSuccess = () => ({
    type: types.UPDATE_PROVIDER_REQUEST_STATUS_SUCCESS,
});

export const updateProviderRequestStatusFailure = (payload) => ({
    type: types.UPDATE_PROVIDER_REQUEST_STATUS_FAILURE,
    payload,
});

export const bulkUpdateProviderRequestTaskRequest = (payload) => ({
    type: types.BULK_UPDATE_PROVIDER_REQUEST_TASK_REQUEST,
    payload,
});

export const bulkUpdateProviderRequestTaskSuccess = () => ({
    type: types.BULK_UPDATE_PROVIDER_REQUEST_TASK_SUCCESS,
});

export const bulkUpdateProviderRequestTaskFailure = (payload) => ({
    type: types.BULK_UPDATE_PROVIDER_REQUEST_TASK_FAILURE,
    payload,
});

export const checkProviderRequestAdhocRequest = (payload) => ({
    type: types.CHECK_PROVIDER_REQUEST_ADHOC_REQUEST,
    payload,
});

export const checkProviderRequestAdhocSuccess = (payload) => ({
    type: types.CHECK_PROVIDER_REQUEST_ADHOC_SUCCESS,
    payload,
});

export const checkProviderRequestAdhocFailure = (payload) => ({
    type: types.CHECK_PROVIDER_REQUEST_ADHOC_FAILURE,
    payload,
});

export const saveProviderRequestAdhocRequest = (payload) => ({
    type: types.SAVE_PROVIDER_REQUEST_ADHOC_REQUEST,
    payload,
});

export const saveProviderRequestAdhocSuccess = (payload) => ({
    type: types.SAVE_PROVIDER_REQUEST_ADHOC_SUCCESS,
    payload,
});

export const saveProviderRequestAdhocFailure = (payload) => ({
    type: types.SAVE_PROVIDER_REQUEST_ADHOC_FAILURE,
    payload,
});

export const scheduleRequestTransactionRequest = (payload) => ({
    type: types.SCHEDULE_REQUEST_TRANSACTION_REQUEST,
    payload,
});

export const scheduleRequestTransactionSuccess = (payload) => ({
    type: types.SCHEDULE_REQUEST_TRANSACTION_SUCCESS,
    payload,
});

export const scheduleRequestTransactionFailure = (payload) => ({
    type: types.SCHEDULE_REQUEST_TRANSACTION_FAILURE,
    payload,
});

export const setProviderRequestFilters = (payload) => ({
    type: types.SET_PROVIDER_REQUEST_FILTERS,
    payload,
});
